import store from "@/store";

export const ageGuard = (to: any, from: any, next: any) => {
  console.debug(`[GUARD] - [ageGuard] - Checking ${to.fullPath}`);

  if (store.state.user.age_verified) {
    console.debug(`[GUARD] - [ageGuard] - ${to.fullPath}  succeeded.`);
    return next();
  } else {
    console.debug(
      `[GUARD] - [ageGuard] - ${to.fullPath} failed, is '${store.state.user.age_verified}'. Go to /verify_age`
    );

    return next("/verify_age");
  }
};

export const notAgeGuard = (to: any, from: any, next: any) => {
  // Use so that already verified users cannot access the verification page.
  console.debug(`[GUARD] - [notAgeGuard] - Checking ${to.fullPath}`);

  if (store.state.user.age_verified) {
    console.debug(
      `[GUARD] - [notAgeGuard] - ${to.fullPath} failed, is '${store.state.user.age_verified}'. Go to /`
    );
    return next("/");
  } else {
    console.debug(`[GUARD] - [notAgeGuard] - ${to.fullPath}  succeeded.`);
    return next();
  }
};
